import React from 'react';
import cn from 'classnames';
import './EngineMarks.scss';

export default function Marks({ data, onClickMark }) {
  return data.marks.map((el) => {
    return (
      <button
        key={el.fields.index.value}
        className={cn(
          'mark',
          `mark_${el.fields.index.value}`,
          el.open && `mark_${el.fields.index.value}_active`
        )}
        onClick={() => onClickMark(el.fields.index.value)}
      />
    );
  });
}
